module.exports = __webpack_public_path__ + "img/zh_CN.e0e1863.jpg";